import script from "./finalInspectionDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./finalInspectionDetails.vue?vue&type=script&setup=true&lang=ts"

import "./finalInspectionDetails.vue?vue&type=style&index=0&id=d65f8c3a&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d65f8c3a"]])

export default __exports__